module.exports = (event) => {
  const { name, description, start_datetime, end_datetime, location } = event;

  const formatDate = (dateString) =>
    new Date(dateString).toISOString().replace(/-|:|\.\d\d\d/g, "");

  const dates = `${formatDate(start_datetime)}/${formatDate(end_datetime)}`;

  const url =
    `https://www.google.com/calendar/render?action=TEMPLATE` +
    `&text=${encodeURIComponent(name)}` +
    `&dates=${dates}` +
    // `&details=${encodeURIComponent(description)}` +
    `&location=${encodeURIComponent(location)}`;

  window.open(url, "_blank");
};
